import Link from 'next/link';
import PropTypes from 'prop-types';
// Components
import Button from '../../atoms/Button/Button';
// Styles
import styles from './CTABlock.module.css';

function CTABlock({
  title,
  subtext,
  ctaLabel,
  ctaLink,
  ctaType,
}) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.textsWrapper}>
        <span className={styles.title}>{title}</span>
        <p className={styles.subtext}>{subtext}</p>
      </div>
      <Link href={`${ctaLink}`} name={ctaLabel} className={styles.ctaLink}>
        <Button
          CTAType={ctaType}
          color="primary"
          usageContext="light"
          className={styles.ctaLabel}
          icon="arrowRight"
          iconPosition="right"
        >
          {ctaLabel}
        </Button>
      </Link>
    </div>
  );
}

CTABlock.propTypes = {
  title: PropTypes.string.isRequired,
  subtext: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
  ctaType: PropTypes.string.isRequired,
};

export default CTABlock;
